<script setup lang="ts">
import type { CollectionFragment } from '#graphql-operations'

defineProps<{
  collection: CollectionFragment
}>()
</script>

<template>
  <NuxtLinkLocale
    class="block"
    :to="`/collections/${collection.id}/${collection.slug}`"
  >
    <div class="hover:shadow-xs relative flex items-center justify-between gap-2 overflow-hidden rounded bg-slate-100 px4 py2 transition duration-200">
      <span class="line-clamp-2 grow text-ellipsis break-words text-xs text-slate-900 fw700 leading-snug hyphens-auto sm:text-sm md:fw500">
        {{ collection.name }}
      </span>
      <div v-if="collection.featuredAsset?.preview" class="min-w-[2.5rem] flex shrink-0 items-center justify-center">
        <div
          class="[&>img]:object-fit relative h0 w-full overflow-hidden rounded bg-slate-100 pt-[100%] [&>img]:absolute [&>img]:inset-[5%] [&>img]:m-auto [&>img]:aspect-1/1 [&>img]:w-full [&>img]:rounded [&>img]:object-center"
        >
          <NuxtImg
            height="100"
            width="100"
            decoding="async"
            loading="lazy"
            :src="collection.featuredAsset?.preview ?? '/placeholder.jpg'"
            :alt="collection.name"
          />
        </div>
      </div>
    </div>
  </NuxtLinkLocale>
</template>
